export const carouselData = [
    {
        id: 1,
        src: `https://s3.amazonaws.com/img.mynetdiary.com/images/success-story-julie@1x.png`,
        name: "Julie Martel",
        benefit: "LOST 71 LB (35%) AND MAINTAINED AFTER 492 DAYS",
        qoute: "“My life changed. My life is beautiful! I am beautiful!!!”",
    },
    {
        id: 2,
        src: `https://s3.amazonaws.com/img.mynetdiary.com/images/success-story-carrie@1x.png`,
        name: "Carrie Hammond",
        benefit: "LOST AND MAINTAINED 103 LBS (40%) AFTER 616 DAYS.",
        qoute: "“I love having a desire to go out and experience new things without worrying about if I'm too fat to do something.”",
    },
    {
        id: 3,
        src: `https://s3.amazonaws.com/img.mynetdiary.com/images/success-paul-reynolds@1x.png`,
        name: "Paul Reynolds",
        benefit: "LOST 50LB (22%) AND MAINTAINED AFTER 345 DAYS.",
        qoute: "“The ability to track using MyNetDiary has been so important.”",
    },
    {
        id: 4,
        src: `https://s3.amazonaws.com/img.mynetdiary.com/images/success-story-joe@1x.png`,
        name: "Joe Balfe",
        benefit: "LOST 65LB (20%) AND MAINTAINED AFTER 216 DAYS.",
        qoute: "“MyNetDiary helps me know exactly how many calories I consume.”",
    },
    {
        id: 5,
        src: `https://s3.amazonaws.com/img.mynetdiary.com/images/success-rick-white@1x.png`,
        name: "Rick White",
        benefit: "LOST 91 LB (30%) AND MAINTAINED AFTER 881 DAYS.",
        qoute: "“I went body surfing for 4 hours straight with my 28 year old son and felt great!”",
    },
    {
        id: 6,
        src: `https://s3.amazonaws.com/img.mynetdiary.com/images/success-matthew-warner@1x.png`,
        name: "Matthew Warner",
        benefit: "LOST 29LB (14%) AND MAINTAINED AFTER 379 DAYS.",
        qoute: "“I used your product religiously for two years and it made a huge difference in my health and happiness.”",
    },
]